import { UnstyledLinkProps } from '@ardoq/link';
import { LinkButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';
import { Island } from '@ardoq/page-layout';
import { EmptyState, EmptyStateToAddIllustration } from '@ardoq/status-ui';

export type NoPriorityFieldsBannerProps = {
  configureLinkProps: UnstyledLinkProps;
  componentTypeName: string;
  i18nLocale: I18nLocale;
};

export const NoPriorityFieldsBanner = ({
  configureLinkProps,
  componentTypeName,
  i18nLocale,
}: NoPriorityFieldsBannerProps) => (
  <Island maxWidth="100%" minWidth="100%" bodySpacing="large">
    <EmptyState
      media={<EmptyStateToAddIllustration />}
      title={t(
        i18nLocale,
        'priorityFields:noPriorityFields.title',
        'No priority fields selected'
      )}
      description={t(
        i18nLocale,
        'priorityFields:noPriorityFields.description',
        { componentTypeName },
        `Make it easier for everyone to find important information. Select the priority {{componentTypeName}} fields to highlight in this section`
      )}
      layout="horizontal"
    >
      <LinkButton {...configureLinkProps}>
        {t(
          i18nLocale,
          'priorityFields:noPriorityFields.button',
          'Select priority fields'
        )}
      </LinkButton>
    </EmptyState>
  </Island>
);
